import { Select } from 'antd';
import React from 'react';

const { Option } = Select;

const MetodoPago = ({
  handleFormChange,
  metodoPago,
  form,
  listaMetodoPago,
  ...props
}) => {
  const selectProps =
    metodoPago !== undefined
      ? {
          value: metodoPago,
          onChange: (e) => handleFormChange(e, 'metodoPago')
        }
      : {};
  return (
    <Select
      {...props}
      {...selectProps}
      title={!listaMetodoPago.length > 0 ? 'Primero seleccione un Plan' : ''}
      style={{ width: '100%' }}
      placeholder="Elegir el medio de pago"
      // notFoundContent="Debe seleccionar un plan"
      disabled={!listaMetodoPago.length > 0}
    >
      {listaMetodoPago.map((item) => (
        <Option key={item.id} value={item.id}>
          {item.descripcion}
        </Option>
      ))}
    </Select>
  );
};

export default MetodoPago;
